import { render, staticRenderFns } from "./HolidayViewModal.vue?vue&type=template&id=785372c0&scoped=true"
import script from "./HolidayViewModal.vue?vue&type=script&lang=js"
export * from "./HolidayViewModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "785372c0",
  null
  
)

export default component.exports